import {Card, Col, List, Radio, Row} from 'antd';
import moment from 'moment';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Request from '../../request';

const data = [
    {name: 'Group A', value: 525},
    {name: 'Group B', value: 175}
];

const COLORS = ['#56BFEE', '#69ccf9'];


class BlankDashboard extends Component {

    constructor(props) {
        super(props)
        this.state = {
            value: 'lastMonth',
            visaStatusCount: {visaFillings: []},
            drawer: false,
            drawerParam: {}
        }
    }

    async componentDidMount() {
        this.loadAllApis();
    }

    loadAllApis = () => {
        let localUser = JSON.parse(localStorage.getItem('user'))

        
    }

    componentWillReceiveProps(props) {
        const {timer} = this.props;
        if (props.timer !== timer) {
            this.loadAllApis();
        }
    }

    render() {
        const {dispatch} = this.props;

        return (
            <div>
                
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
(BlankDashboard)
